import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from './../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CatalogosService {
  TOKEN = localStorage.getItem('token');


  constructor(private http:HttpClient) { }

  agregarEstola(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarEstola/", data);
  }

  editarEstola(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/editarEstola/", data);
  }

  updateEstola(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/updateEstola/", data);
  }

  agregarSesionTematica(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarSesionTematica/", data);
  }

  editarSesionTematica(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/editarSesionTematica/", data);
  }

  updateSesionTematica(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/updateSesionTematica/", data);
  }


  agregarFondo(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarFondo/", data);
  }

  agregarFoto(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarFoto/", data);
  }

  agregarFotosGrupo(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarFotosGrupo/", data);
  }

  getFotosGrupo(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getFotosGrupo/", data);
  }

  eliminarFotoGrupo(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/eliminarFotoGrupo/", data);
  }


  eliminarFoto(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/eliminarFoto/", data);
  }

  editarFondo(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/editarFondo/", data);
  }

  updateFondo(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/updateFondo/", data);
  }

  agregarPlaca(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarPlaca/", data);
  }

  editarPlaca(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/editarPlaca/", data);
  }

  updatePlaca(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/updatePlaca/", data);
  }

  agregarMoldura(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarMoldura/", data);
  }

  editarMoldura(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/editarMoldura/", data);
  }

  updateMoldura(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/updateMoldura/", data);
  }

  agregarEscuela(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarEscuela/", data);
  }

  editarEscuela(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/editarEscuela/", data);
  }

  updateEscuela(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/updateEscuela/", data);
  }


  getEstados(): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getEstados/");
  }

  getColores(): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getColores/");
  }

  getCodigosDescuento(): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getCodigosDescuento/");
  }

  getDetalleCodigo(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getDetalleCodigo/", data);
  }

  agregarDescuento(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarDescuento/", data);
  }


  updateCodigoDescuento(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/updateCodigoDescuento/", data);
  }

  getMunicipios(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getMunicipios/", data);
  }

  agregarMunicipio(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarMunicipio/", data);
  }

  agregarCarrera(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarCarrera/", data);
  }

  editarCarrera(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/editarCarrera/", data);
  }

  updateCarrera(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/updateCarrera/", data);
  }


  agregarColor(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarColor/", data);
  }

  editarColor(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/editarColor/", data);
  }

  updateColor(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/updateColor/", data);
  }

  getFondosMolduras(): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getFondosMolduras/");
  }

  agregarFondoMoldura(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarFondoMoldura/", data);
  }

  editarFondoMoldura(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/editarFondoMoldura/", data);
  }

  updateFondoMoldura(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/updateFondoMoldura/", data);
  }


  getGastos(): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getGastos/", {headers});
  }

  getClasificacionesGasto(): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getClasificacionesGasto/", {headers});
  }

  getGastosFiltrados(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json',  Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getGastosFiltrados/", data,  {headers});
  }

  getCategoriasGastoClasificacion(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json',  Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getCategoriasGastoClasificacion/", data,  {headers});
  }

  agregarGasto(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarGasto/", data);
  }


  editarGasto(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/editarGasto/", data, {headers});
  }
  

  updateGasto(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/updateGasto/", data);
  }

  eliminarGasto(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/eliminarGasto/", data, {headers});
  }

  getCategoriasGasto(): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getCategoriasGasto/", {headers});
  }


  getFotosCliente(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getFotosCliente/", data, {headers});
  }
  
  getFlujoEfectivo(): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getFlujoEfectivo/", {headers});
  }


  getAgradecimientos(): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getAgradecimientos/", {headers});
  }

  agregarAgradecimiento(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarAgradecimiento/", data, {headers});
  }

  editarAgradecimiento(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/editarAgradecimiento/", data, {headers});
  }
  
  updateAgradecimiento(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/updateAgradecimiento/", data, {headers});
  }


  getDiplomas(): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getDiplomas/", {headers});
  }

  agregarDiploma(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarDiploma/", data, {headers});
  }

  editarDiploma(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/editarDiploma/", data, {headers});
  }
  
  updateDiploma(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/updateDiploma/", data, {headers});
  }
}
